"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyMomentModal = void 0;

var _reactRouter = require("react-router");

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _molecules = require("../../molecules");

var _PreviewCard = require("../PreviewCard");

require("./MyMomentModal.css");

var _tags = require("../../util/tags");

var _helpers = require("../../util/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// MyMomentModal
var MyMomentModal = function MyMomentModal(_ref) {
  var moment = _ref.moment,
      allMoments = _ref.allMoments,
      utmCampaign = _ref.utmCampaign,
      onPreviousMoment = _ref.onPreviousMoment,
      onNextMoment = _ref.onNextMoment,
      onClose = _ref.onClose,
      onCopyLink = _ref.onCopyLink,
      onDownload = _ref.onDownload,
      onSendEmail = _ref.onSendEmail,
      onShareClick = _ref.onShareClick,
      onFacebookShare = _ref.onFacebookShare,
      onAddToTraceIDClick = _ref.onAddToTraceIDClick,
      onTwitterShare = _ref.onTwitterShare,
      onGoToGame = _ref.onGoToGame,
      onGoToMoment = _ref.onGoToMoment;
  var location = (0, _reactRouter.useLocation)();
  var history = (0, _reactRouter.useHistory)();
  var rank = allMoments && moment ? allMoments.findIndex(function (it) {
    return it.game_clip_id === moment.game_clip_id;
  }) : null;
  var itemsLength = allMoments ? allMoments.length - 1 : null;
  var open = true; // Button handling

  var copyLink = function copyLink(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onCopyLink === "function") {
      onCopyLink(e, moment);
    }
  };

  var download = function download(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onDownload === "function") {
      onDownload(e, moment);
    }
  };

  var sendEmail = function sendEmail(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onSendEmail === "function") {
      onSendEmail(e, moment);
    }
  };

  var shareClick = function shareClick(e) {
    if (typeof onShareClick === "function") {
      onShareClick(e, moment);
    }
  };

  var twitterShare = function twitterShare(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onCopyLink === "function") {
      onTwitterShare(e, moment);
    }
  };

  var facebookShare = function facebookShare(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onFacebookShare === "function") {
      onFacebookShare(e, moment);
    }
  };

  var addToTraceIDClick = function addToTraceIDClick(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onAddToTraceIDClick === "function") {
      onAddToTraceIDClick(e, moment);
    }
  };

  var momentClick = function momentClick(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    (0, _.trackEvent)("Preview Moment Pressed");
  };

  var goToGame = function goToGame(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onGoToGame === "function") {
      onGoToGame(e, moment);
    }
  };

  var goToMoment = function goToMoment(e) {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();

    if (typeof onGoToMoment === "function") {
      onGoToMoment(e, moment);
    }
  }; // Formatters


  var formatTime = function formatTime(time) {
    var formattedTime = "";

    if (time) {
      var m = 0;
      var s = 0;
      var total = time;
      m = Math.floor(total / 60);
      total = total - m * 60;
      s = Math.floor(total);

      if (s < 10) {
        s = "0".concat(s);
      }

      formattedTime = "".concat(m, ":").concat(s);
    }

    return formattedTime;
  };

  var formattedMomentTime = moment ? formatTime(moment.dynamic_start) : null; // Renderers

  var renderTags = function renderTags() {
    return /*#__PURE__*/_react.default.createElement(_molecules.MomentTags, {
      tags: (0, _.generateHumanTags)(moment)
    });
  };

  var memoizedRenderTags = (0, _react.useMemo)(function () {
    return renderTags(moment);
  }, [moment]);

  var renderGameTitle = function renderGameTitle() {
    // Get home & away teams and scores
    var awayTeam = moment === null || moment === void 0 ? void 0 : moment.away_team;
    var homeTeam = moment === null || moment === void 0 ? void 0 : moment.home_team;
    var scoreString = homeTeam !== null && homeTeam !== void 0 && homeTeam.score && awayTeam !== null && awayTeam !== void 0 && awayTeam.score ? "".concat(homeTeam.score, ":").concat(awayTeam.score) : ""; // Determine the game result

    var gameResult = homeTeam && awayTeam ? (0, _helpers.gameResultAsString)(homeTeam, awayTeam) : "";
    var updatedTimeAgo = moment ? (0, _helpers.capitalizeFirstLetter)((0, _helpers.formatUTCTimestampAsTimeAgo)(moment.start_time)) : ""; // Future: switch out start_time for update_time
    // Construct the detail string

    var details = (moment === null || moment === void 0 ? void 0 : moment.type) !== "CustomUpload" ? moment ? "".concat(updatedTimeAgo, " in a ").concat(scoreString, " ").concat(gameResult, " ").concat(awayTeam.title) : "" : "Uploaded ".concat(updatedTimeAgo);
    return /*#__PURE__*/_react.default.createElement(_.Label, null, details);
  };

  var memoizedRenderGameTitle = (0, _react.useMemo)(function () {
    return renderGameTitle(moment);
  }, [moment]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Element, {
    trkContext: "MyMomentModal",
    className: "MyMomentModal"
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "left-arrow",
    span: 1
  }, rank > 0 && /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    trkAction: "Previous Moment Pressed",
    icon: _.Icon.Type.CheveronLeft,
    color: _.Color.White2,
    iconSize: 24,
    size: 56,
    onClick: onPreviousMoment
  })), /*#__PURE__*/_react.default.createElement(_PreviewCard.PreviewCard, {
    open: open,
    item: moment,
    showAvatars: false,
    copyLink: copyLink,
    download: download,
    showTeamTitle: false,
    sendEmail: sendEmail,
    twitter: twitterShare,
    showShareButton: false,
    showPlayerNames: false,
    facebook: facebookShare,
    onPreviewClose: onClose,
    thisGame: goToGame,
    showSmallShareButton: true,
    showShadeCloseButton: false,
    showAddToTraceIdButton: true,
    onShareClicked: shareClick,
    onMomentClick: momentClick,
    thisMoment: goToMoment,
    onAddToTraceIDClick: addToTraceIDClick,
    key: "mymomentpreviewcard-".concat(moment === null || moment === void 0 ? void 0 : moment.game_clip_id)
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "moment-time",
    bold: true,
    marginRight: 4,
    marginBottom: 4
  }, formattedMomentTime), /*#__PURE__*/_react.default.createElement(_.Row, {
    alignItems: "center",
    justifyCenter: "center"
  }, memoizedRenderTags), /*#__PURE__*/_react.default.createElement(_.Element, {
    marginTop: 4
  }, memoizedRenderGameTitle)), /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "right-arrow",
    marginLeft: 4
  }, rank < itemsLength && /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    trkAction: "Next Moment Pressed",
    icon: _.Icon.Type.CheveronRight,
    color: _.Color.White2,
    iconSize: 24,
    size: 56,
    onClick: onNextMoment
  }))));
};

exports.MyMomentModal = MyMomentModal;